/**
 * Constants for translation building
 * Centralized to avoid magic strings scattered throughout code
 */

// Parameter keys as object for type safety
export const PARAMETER_KEYS = {
  DURATION: 'duration',
  ACTION_TYPE: 'actionType',
  INPUT_NODES: 'inputNodes',
  OUTPUT_NODES: 'outputNodes',
  GRADIENT_PROGRAM: 'GradientProgram',
  TOTAL_PUMPS: 'totalPumps',
  OPERATION_NAME: 'operationName',
  SELECTED_LINK: 'selectedLink',
  IS_SOURCE_EDGE: 'isSourceEdge',
  OUTPUT_EDGE: 'outputEdge',
  STEPS: 'steps',
  INPUT: 'input',
  UNITS: 'units',
  TRANSLATION_TEMPLATE: 'translationTemplate',
  PARAMETERS: 'parameters',
} as const;

// Excluded keys as Set<string> for flexible runtime use
export const EXCLUDED_PARAM_KEYS: Set<string> = new Set([
  'actionType',
  'inputNodes',
  'outputNodes',
  'duration',
  'GradientProgram',
  'totalPumps',
  'operationName',
  'selectedLink',
  'isSourceEdge',
  'outputEdge',
  'steps',
]);

// Non-parameter keys that should be skipped during normalization
export const NON_PARAM_KEYS: Set<string> = new Set([
  'input',
  'units',
  'selectedLink',
  'translationTemplate',
  'parameters',
  'operationName',
  'steps',
  'isSourceEdge',
  'outputEdge',
  '_id',
]);

export const FIELD_TYPES = {
  DROPDOWN: 'dropdown',
  GROUP: 'group',
  RANGE: 'range',
  TABLE: 'table',
  UNITS: 'units',
} as const;

export const OPERATION_ARCHETYPES = {
  TRANSFER: 'TRANSFER',
  MEASURE: 'MEASURE',
  COMPLEX: 'COMPLEX',
  TRANSFORM: 'TRANSFORM',
} as const;

export const MEASURE_OPERATIONS = [
  'absorbance',
  'fluorescence',
  'luminescence',
  'sequencing',
  'flow cytometry',
  'gel electrophoresis',
  'hplc',
  'auc',
  'cd',
  'weigh',
] as const;

// Normalization constraints
export const NORMALIZATION_DEPTH_LIMIT = 4;
export const MIN_FIELD_WIDTH = 100;
export const CHAR_WIDTH_MULTIPLIER = 12;
